import _map from "lodash/map";
import _isEmpty from "lodash/isEmpty";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import React from 'react';
import analyticsLib from '@nerdwallet/analytics';
import { ElementImpression, ElementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import { Link } from '@nerdwallet/currency';
import { ENTITY_NAME, EVENT_TYPES, FORM_NAME } from '../../lib/analytics-constants';
import styles from '../comparison-grid.module.less';
import SearchWrapper from './search-wrapper';
import { getSearchLabel, getSearchPlaceholder } from '../../lib/product-constants';

/*
 * Shows a marketplace search component
 */
export var SearchEntityToCompare = function SearchEntityToCompare(_ref) {
  var addEntityClickHandler = _ref.addEntityClickHandler,
      entitiesToCompare = _ref.entitiesToCompare,
      productType = _ref.productType,
      tabName = _ref.tabName,
      updateShouldShowSearch = _ref.updateShouldShowSearch;

  // cancel button handler; hides the search
  var cancelClickHandler = function cancelClickHandler() {
    analyticsLib.track(EVENT_TYPES.FORM_CANCELLED, {
      form_name: FORM_NAME.COMPARISON_GRID_ADD_ENTITY
    });
    updateShouldShowSearch(false);
  };
  /*
   * OnClick when an entity is selected from the search results
   * to add the entity in the compare entities list
   * @param {entitiesFromSearch} - search results
   */


  var addClickHandler = function addClickHandler(entitiesFromSearch) {
    if (!_isEmpty(entitiesFromSearch)) {
      var selectedEntityIds = _map(entitiesToCompare, function (selectedEntity) {
        return selectedEntity === null || selectedEntity === void 0 ? void 0 : selectedEntity.id;
      }); // Determine which ids from the search results need to be added to the compare module


      var entitiesToAdd = entitiesFromSearch.filter(function (entityToAdd) {
        return !selectedEntityIds.includes(entityToAdd === null || entityToAdd === void 0 ? void 0 : entityToAdd.id);
      }); // add the entity only if the entity is not already present in the entity to compare
      // else exit and hide entity search

      if (!_isEmpty(entitiesToAdd)) {
        var ids = _map(entitiesToAdd, function (entityToAdd) {
          return entityToAdd === null || entityToAdd === void 0 ? void 0 : entityToAdd.id;
        });

        addEntityClickHandler(ids);
      }

      updateShouldShowSearch(false);
    }
  };

  var searchAnalyticsProp = {
    formName: FORM_NAME.COMPARISON_GRID_ADD_ENTITY,
    sectionName: tabName
  };
  var searchLabel = /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, getSearchLabel(productType));
  var searchPlaceholder = getSearchPlaceholder(productType);
  return /*#__PURE__*/React.createElement(ElementImpression, {
    id: ENTITY_NAME.COMPARISON_GRID_ENTITY_SEARCH,
    elementName: ENTITY_NAME.COMPARISON_GRID_ENTITY_SEARCH,
    sectionCategory: tabName
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.searchEntityContent
  }, /*#__PURE__*/React.createElement(SearchWrapper, {
    label: searchLabel,
    placeholder: searchPlaceholder,
    analytics: searchAnalyticsProp,
    onSelectHandler: addClickHandler,
    productType: productType
  }), /*#__PURE__*/React.createElement(ElementInteraction, {
    elementCategory: EVENT_TYPES.FORM_CANCELLED,
    elementName: ENTITY_NAME.COMPARISON_GRID_ADD_ENTITY,
    type: "CLICK",
    id: "".concat(ENTITY_NAME.COMPARISON_GRID_ADD_ENTITY, "_").concat(EVENT_TYPES.FORM_CANCELLED)
  }, /*#__PURE__*/React.createElement(Link, {
    className: styles.cancelLink,
    onClick: cancelClickHandler
  }, "Cancel"))));
};